export default __webpack_public_path__ + "static/fab-b7c89a2e895f7a63af93c811c34a40a8.webp";